import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import HeroCarousel from "./components/HeroCarousel";
import DramaOverview from "./components/DramaOverview";
import LatestEpisodes from "./components/LatestEpisodes";
import RelatedSpotlight from "./components/RelatedSpotlight";

export default function Home() {
  useSeo({
    title: "善良的小姨子在线观看 - 高清电视剧免费在线观看平台",
    description:
      "善良的小姨子在线观看网站提供该剧集的最新高清资源，覆盖剧情介绍、演员信息及播放更新，满足用户在线观看及追剧需求。",
    keywords: "善良的小姨子,善良的小姨子在线观看,电视剧在线观看,善良的小姨子剧情,电视剧资源,追剧平台,影视在线播放",
  });

  return (
    <SiteLayout>
      <HeroCarousel />
      <DramaOverview />
      <LatestEpisodes />
      <RelatedSpotlight />

      <section className="w-full px-4 md:px-8 py-10 md:py-14 bg-background-100">
        <div className="rounded-lg bg-primary-500 px-6 md:px-10 py-8 md:py-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="text-center md:text-left">
            <h3 className="font-heading text-xl md:text-3xl font-bold text-background-50">
              共 {24} 集高清剧集，等你在老宅的餐桌旁坐下
            </h3>
            <p className="text-primary-100 text-sm md:text-base mt-2">
              从第一集到最新一集，随时回到那个充满烟火气的家。
            </p>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/play/1"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm md:text-base font-medium hover:bg-accent-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-play-fill text-lg"></i> 从第一集开始
            </Link>
            <Link
              to="/play/18"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 text-primary-700 text-sm md:text-base font-medium hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-flashlight-fill"></i> 看最新一集
            </Link>
          </div>
        </div>
      </section>
    </SiteLayout>
  );
}